// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"77ab36e7","296":"5ba4399a","387":"57354016","646":"457c065f","831":"55094b48","932":"8a3c7d15"}[chunkId] + ".chunk.css";
};